import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import cx from 'classnames';
import { ButtonGroupContext } from './button-group-context';
const StyledButtonGroup = styled.div `
  background-color: ${() => 'var(--button-group-color)'};
  height: 22px;
  padding: 0px 2px;
  display: inline-flex;
  align-items: center;
  border-radius: 4px;
  border: none;
`;
const defaultValue = {
    isButtonGroup: true,
};
export const ButtonGroup = (props) => {
    const [selected, setSelected] = useState(props.defaultSelected);
    const handleSelected = useCallback((id) => {
        setSelected(id);
    }, []);
    return (React.createElement(ButtonGroupContext.Provider, { value: Object.assign(Object.assign({}, defaultValue), { onSelected: handleSelected, selected, buttonTheme: props.buttonTheme }) },
        React.createElement(StyledButtonGroup, { className: cx('button-group', props.className), "data-role": "button-group" }, props.children)));
};
